export default {
    namespaced: true,

    state: {
        score: 0,
        bonuses: [ 0, 0, 0, 0, 0 ]
    },

    getters: {
        score: state => state.score,
        bonuses: state => state.bonuses
    },

    mutations: {
        setScore: ( state, value ) =>
        {
            let newScore = Math.max( 0, state.score + value );
            state.score = newScore;
        },

        setBonusses: ( state, value ) =>
        {
            state.bonuses[ value - 1 ] = 1;
        },

        resetValues: state =>
        {
            state.score = 0;
            state.bonuses = [ 0, 0, 0, 0, 0 ];
        }
    },

    actions: {
        score( context, payload )
        {
            context.commit( 'setScore', payload.value );
        },

        foundBonus( context, payload )
        {
            context.commit( 'setBonusses', payload.value );
        },

        resetValues( context )
        {
            context.commit( 'resetValues' );
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/store/modules/game.js